
<!-- <div *ngIf="isLoading" class="loader">Please Wait Movies,Stream,Series Loading...</div> -->
 <div class="loading-wrapper" *ngIf="isLoadingdb">
  <div class="top-bar">
    <!-- <button class="back-btn">←</button>
    <span>Refreshing Media Contents</span> -->
  </div>

  <div class="status-container">
    <div class="status-box" *ngFor="let item of loadingItems">
      <div class="label">{{ item.label }}</div>
      <div
        class="status"
        [ngClass]="{ 'complete': item.loaded, 'downloading': !item.loaded }"
      >
        {{ item.loaded ? 'Completed' : 'Downloading...' }}
      </div>
    </div>
  </div>

  <div class="spinner"></div>
  <div class="bottom-bar">PLEASE WAIT...</div>
</div>

<div class="container-fluid auth-backgrounds">
  <div class="row m-1">
    <div class="col-md-12 mt-3">
      <div class="header-w3l">
        <div class="logo ml-2">
          <!-- <img class="img-fluid" src="/assets/images/purple-web-player2.png" width="500" alt=""> -->
          <h3>
            <a href="#">{{ "COMMON.TITLE" | translate }}</a>
          </h3>
        </div>
      </div>
    </div>
    
    <!-- <button
      type="button"
      class="btn button-info-playlist justify-content-center"
      (click)="openModal(template)"
      *ngIf="!isLoading && playList.length == 0"
    >
      <svg
        width="50"
        height="50"
        viewBox="0 0 99 99"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="49.1708" cy="49.1708" r="49.1708" fill="#232530" />
        <g filter="url(#filter0_f_17_848)">
          <circle cx="69.8571" cy="64.7739" r="9.6227" fill="#7123F6" />
        </g>
        <circle
          cx="49.0318"
          cy="48.8259"
          r="30.2811"
          fill="#7123F6"
          fill-opacity="0.2"
          stroke="#7123F6"
          stroke-width="4.47007"
        />
        <path
          d="M46.8281 31.2377C46.8281 29.7601 48.026 28.5623 49.5036 28.5623C50.9812 28.5623 52.1791 29.7601 52.1791 31.2377V67.3566C52.1791 68.8343 50.9812 70.0321 49.5036 70.0321C48.026 70.0321 46.8281 68.8343 46.8281 67.3566V31.2377Z"
          fill="white"
        />
        <path
          d="M31.444 51.9728C29.9664 51.9728 28.7686 50.7749 28.7686 49.2973C28.7686 47.8197 29.9664 46.6218 31.444 46.6218L67.5629 46.6218C69.0406 46.6218 70.2384 47.8197 70.2384 49.2973C70.2384 50.7749 69.0406 51.9728 67.5629 51.9728L31.444 51.9728Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_f_17_848"
            x="49.0592"
            y="43.9761"
            width="41.5955"
            height="41.5957"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.58759"
              result="effect1_foregroundBlur_17_848"
            />
          </filter>
        </defs>
      </svg>
      {{ "PLAYLIST.ADD_PLAYLIST" | translate }}
    </button> -->

    <div class="col-12 my-3 d-flex justify-content-end">
      <!-- <button class="logout-purple btn btn-danger text-light mr-2" (click)="clearStorage()" *ngIf="filterPlayList.length>0">
        <i class="fas fa-trash-alt" aria-hidden="true"></i>
      </button> -->
      <div class="float-right d-flex-center">
        <div
          class="spinner-border spinner-border-sm mr-3"
          role="status"
          *ngIf="isLoading"
        >
          <span class="sr-only">{{ "COMMON.LOADING" | translate }}</span>
        </div>
        <button
          type="button"
          class="btn button-info"
          routerLink="/login"
          *ngIf="!isLoading && !isLogin"
        >
          <!-- <i
            class="fa fa-plus px-2 mr-2 p-1"
            style="border-right: 1px solid #23242e"
          ></i
          > -->
          <i class="fa fa-sign-in px-2 p-1 "></i>
          {{ "COMMON.LOGIN" | translate }}
        </button>
        <!-- <button type="button" class="btn button-info ml-3" (click)="onLogout()">
          <i
            class="fa fa-sign-in px-2 mr-2 p-1"
            style="border-right: 1px solid #23242e"
          ></i>
          <span class="links_name">{{ "HOME.LOGOUT" | translate }}</span>
        </button> -->
      </div>
    </div>
    <div class="col-12">
      <div class="row" *ngIf="filterPlayList">
        <div
          class="col-lg-6 col-md-6 col-12 pb-4"
          *ngFor="let item of filterPlayList" (click)="onSelectPlaylist(item)">
          <!-- <span class="cloud" *ngIf="!item.local"><i class="fa fa-cloud"></i></span>
          <span class="cloud" *ngIf="item.local"><i class='fas fa-store-alt'></i></span> -->
          <div
            class="d-flex-center  cursor-pointer pi-play-list-box"
            >
            <span class="vertical-label-color" *ngIf="!item.local">Cloud</span>
            <span class="vertical-label" *ngIf="item.local">Local</span>
            <span class="horizon-code" *ngIf="item.type == 5">Code</span>
            <!-- <img src="assets/images/m3u_list.png" class="playlist-img" *ngIf="item.isM3u"> -->
            <!-- <img
              src="/assets/images/xstream.svg"
              class="playlist-img"
              *ngIf="item.type == 1 || item.type == 4"
            /> -->
            <div class="icon-wrapper"  *ngIf="item.type == 1 || item.type == 4">
            <img src="/assets/images/xstream.svg" alt="icon" />
            </div>

            <div class="icon-wrapper" *ngIf="item.type == 2">

            <img
              src="/assets/images/m3u.svg" alt="icon"
            />
            </div>

            <div class="icon-wrapper" *ngIf="item.type == 5">

              <img
              src="/assets/images/code-login.svg"
              class="playlist-img"
              
              />
            </div>
            <div class="ml-4 name-res">
              <p class="mb-0 fw-500">{{ item.playlist_name }}</p>
              <p class="mb-0 fs-14 search-title" *ngIf="item.type == 1  || item.type == 4 || item.type == 5">
                  {{ (item.dns ? item.dns : (item.dns_id?.dns_url || '')) | slice:0:8 }}**********
              </p>
              <!-- <p class="mb-0 fs-14 search-title" *ngIf="item.type == 5">************</p> -->
              <p class="mb-0 fs-14 search-title" *ngIf="item.type == 2">{{ item.m3u_url | slice:0:8 }}**********</p>
              
            </div>
           
            <!-- <i class="fa fa-trash ml-3 fs-20 ml-auto text-white" aria-hidden="true"
              (click)="deleteItem(item.url,((item.isM3u)?'m3u':'xstream'),$event)"></i> -->
              <svg width="50" height="50" viewBox="0 0 64 63" class="ml-3 ml-auto" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
              <div class="cloud-playlist" *ngIf="!item.device_id && item.local && showCloudUpload < 5" (click)="cloudPlaylist(item);$event.stopPropagation();$event.preventDefault();">
                <!-- <i class="fas fa-cloud-upload-alt" (click)="cloudPlaylist(item);$event.stopPropagation();$event.preventDefault();"></i> -->
                <img src="assets/images/cloud-computing.svg" alt="" >
                
              </div>
              <div class="edit-playlist" *ngIf="!item.device_id" (click)="editPlaylist(item);$event.stopPropagation();$event.preventDefault();">
                <img src="assets/images/edit.svg" alt="" >
                <!-- <i class="fa fa-edit" (click)="editPlaylist(item);$event.stopPropagation();$event.preventDefault();"></i> -->
              </div>
              <div class="delete-playlist" *ngIf="!item.device_id" (click)="deleteItem(item.id,item.local);$event.stopPropagation()">
                <img src="assets/images/delete.svg" alt="" >
                <!-- <i class="fa fa-trash" (click)="deleteItem(item.id,item.local);$event.stopPropagation()"></i>               -->
            </div>
            <div class="delete-playlist" *ngIf="item.app_mode == 'activate'">
                <i class="fa fa-trash" (click)="deleteCode(item.id,item.local);$event.stopPropagation()"></i>              
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div
          class="d-flex align-items-center p-3 cursor-pointer pi-play-list-box"
          (click)="openModal(template)"
        >
            <span class="vertical-label-colors" ></span>

          <!-- <img src="assets/images/m3u_list.png" class="playlist-img" *ngIf="item.isM3u"> -->
          <div class="icon-wrapper">
          <img src="/assets/images/add-playlist.svg" alt="icon"/>
          </div>
         
          <div class="ml-4 name-res">
            <p class="mb-0 fw-500">Add Playlist</p>
            <!-- <p class="mb-0 fs-14 search-title">{{ item.url }}</p> -->
          </div>
          
          
        </div>
        </div>
      </div>
      <!-- <div class="row d-flex justify-content-center mt-5" *ngIf="!filterPlayList.length">
        <div class="error">
          <h3>Please Add Playlist , No playlist added yet!</h3>
        </div>
      </div> -->
    </div>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title title-color">
      {{ "PLAYLIST.ADD_PLAYLIST" | translate }}
    </h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-3 switch-tab-play ml-2 mr-2 mb-2" (click)="playListModal.type = 'fromUrl'"
  [class.active]="playListModal.type === 'fromUrl'">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="loginPlaylist"
            id="fromUrlRadio"
            value="fromUrl"
            [(ngModel)]="playListModal.type"
          />
          <label class="form-check-label" for="fromUrlRadio">{{
            "PLAYLIST.LOAD_PLAYLIST_FROM_URL" | translate
          }}</label>
        </div>
      </div>
      <div class="col-3 switch-tab-play mb-2" (click)="playListModal.type = 'xstreamUrl'"
  [class.active]="playListModal.type === 'xstreamUrl'">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="loginPlaylist"
            id="xstreamUrlRadio"
            [(ngModel)]="playListModal.type"
            value="xstreamUrl"
            required
          />
          <label class="form-check-label " for="xstreamUrlRadio">{{
            "PLAYLIST.LOGIN_WITH_XSTREAM_URL" | translate
          }}</label>
        </div>
      </div>

      <!-- <div class="col-3 mb-2">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="loginPlaylist"
            id="inlineRadio2"
            [(ngModel)]="playListModal.type"
            value="onestreamUrl"
            required
          />
          <label class="form-check-label title-color" for="inlineRadio2">{{
            "PLAYLIST.LOGIN_WITH_ONESTREAM_URL" | translate }}</label>
        </div>
      </div> -->
      
      <div class="col-4 w-50 switch-tab-play ml-2" >
        <button class="btn text-light fs-15 cursor-pointer" (click)="navigateCode()" >Login with Code</button>
      </div>
    </div>
    <form #urlForm="ngForm">
      <div class="row mt-3" *ngIf="playListModal.type == 'fromUrl'">
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Playlist Name <sup class="text-danger">*</sup>
          </label>

          <div
            class="form-group"
            [ngClass]="{ 'mb-0': urlForm.submitted && playlistname.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="{{ 'PLACEHOLDER.PLAYLIST_NAME' | translate }}"
              #playlistname="ngModel"
              [(ngModel)]="playListModal.name"
              name="playlistname"
              required
            />
          </div>
          <div
            *ngIf="urlForm.submitted && playlistname.invalid"
            class="float-left"
          >
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.PLAYLIST_NAME" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >URL<sup class="text-danger">*</sup></label
          >

          <div
            class="form-group"
            [ngClass]="{ 'mb-0': urlForm.submitted && url.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="url"
              placeholder="http://url_here.com:port"
              required
              [(ngModel)]="playListModal.url"
              name="url"
              #url="ngModel"
              [pattern]="url_pattern"
            />
            <!-- pattern="http(s?)(:\/\/)((www.)?)(([^.]+)\.)?([a-zA-z0-9\-_]+)(\/[^\s]*)?" -->
          </div>

          <div *ngIf="urlForm.submitted && url.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14" *ngIf="url.errors.required">
              {{ "FORMERROR.PLAYLIST_URL" | translate }}
            </p>
            <p
              class="error-msg mb-0 fs-14"
              *ngIf="urlForm.controls.url.errors.pattern"
            >
              {{ "FORMERROR.VALID_URL" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn button-info"
            (click)="addPlaylistM3u(urlForm)"
          >
            <i class="fa fa-plus px-2"></i
            >{{ "PLAYLIST.ADD_PLAYLIST" | translate }}
          </button>
        </div>
      </div>
    </form>
    <form #Xform="ngForm">
      <div class="row mt-3" *ngIf="playListModal.type == 'xstreamUrl'">
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Playlist Name<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': Xform.submitted && xplaylist.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="{{ 'PLACEHOLDER.PLAYLIST_NAME' | translate }}"
              #xplaylist="ngModel"
              [(ngModel)]="playListModal.name"
              name=" xplaylist"
              required
            />
          </div>
          <div *ngIf="Xform.submitted && xplaylist.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.PLAYLIST_NAME" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Username<sup class="text-danger">*</sup></label
          >

          <div
            class="form-group"
            [ngClass]="{ 'mb-0': Xform.submitted && xuname.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="uname"
              placeholder="{{ 'PLACEHOLDER.USERNAME' | translate }}"
              #xuname="ngModel"
              [(ngModel)]="playListModal.userName"
              name="xuname"
              required
            />
          </div>
          <div *ngIf="Xform.submitted && xuname.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.USERNAME" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Password<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': Xform.submitted && xpassword.invalid }"
          >
            <input
              [type]="type"
              class="form-control"
              id="password"
              placeholder="{{ 'PLACEHOLDER.PASSWORD' | translate }}"
              #xpassword="ngModel"
              [(ngModel)]="playListModal.password"
              name="xpassword" maxlength="16"
              required
            />
            <div class="input-append cursor-pointer text-dark" (click)="hideShowPassword()">
              <i class="fas fa-eye-slash " *ngIf="type == 'password'"></i>
              <i class="fas fa-eye " *ngIf="type !== 'password'"></i>
            </div> 
          </div>
          <div *ngIf="Xform.submitted && xpassword.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.PASSWORD" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >URL<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': Xform.submitted && xurl.invalid }"
          >
            <input
              type="url"
              class="form-control"
              id="url"
              placeholder="http://url_here.com:port"
              #xurl="ngModel"
              [(ngModel)]="playListModal.url"
              name="xurl"
              [pattern]="url_pattern"
              required
            />
            <!-- pattern="http(s?)(:\/\/)((www.)?)(([^.]+)\.)?([a-zA-z0-9\-_]+)(\/[^\s]*)?" -->
          </div>
          <div *ngIf="Xform.submitted && xurl.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14" *ngIf="xurl.errors.required">
              {{ "FORMERROR.PLAYLIST_URL" | translate }}
            </p>
            <p
              class="error-msg mb-0 fs-14"
              *ngIf="Xform.controls.xurl.errors.pattern"
            >
              {{ "FORMERROR.VALID_URL" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn button-info"
            (click)="addPlaylistXstream(Xform)"
          >
            <i class="fa fa-plus px-2"></i
            >{{ "PLAYLIST.ADD_PLAYLIST" | translate }}
          </button>
        </div>
      </div>
    </form>
    <form #OneXForm="ngForm">
      <div class="row mt-3" *ngIf="playListModal.type == 'onestreamUrl'">
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Playlist Name<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': OneXForm.submitted && xplaylist.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="name"
              placeholder="{{ 'PLACEHOLDER.PLAYLIST_NAME' | translate }}"
              #xplaylist="ngModel"
              [(ngModel)]="playListModal.name"
              name=" xplaylist"
              required
            />
          </div>
          <div *ngIf="OneXForm.submitted && xplaylist.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.PLAYLIST_NAME" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Username<sup class="text-danger">*</sup></label
          >

          <div
            class="form-group"
            [ngClass]="{ 'mb-0': OneXForm.submitted && xuname.invalid }"
          >
            <input
              type="text"
              class="form-control"
              id="uname"
              placeholder="{{ 'PLACEHOLDER.USERNAME' | translate }}"
              #xuname="ngModel"
              [(ngModel)]="playListModal.userName"
              name="xuname"
              required
            />
          </div>
          <div *ngIf="OneXForm.submitted && xuname.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.USERNAME" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >Password<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': OneXForm.submitted && xpassword.invalid }"
          >
            <input
              [type]="type"
              class="form-control"
              id="password"
              placeholder="{{ 'PLACEHOLDER.PASSWORD' | translate }}"
              #xpassword="ngModel"
              [(ngModel)]="playListModal.password"
              name="xpassword" maxlength="16"
              required
            />
            <div class="input-append cursor-pointer text-dark" (click)="hideShowPassword()">
              <i class="fas fa-eye-slash " *ngIf="type == 'password'"></i>
              <i class="fas fa-eye " *ngIf="type !== 'password'"></i>
            </div> 
          </div>
          <div *ngIf="OneXForm.submitted && xpassword.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14">
              {{ "FORMERROR.PASSWORD" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <label for="" class="text-dark mb-0"
            >URL<sup class="text-danger">*</sup></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'mb-0': OneXForm.submitted && xurl.invalid }"
          >
            <input
              type="url"
              class="form-control"
              id="url"
              placeholder="http://url_here.com:port"
              #xurl="ngModel"
              [(ngModel)]="playListModal.url"
              name="xurl"
              [pattern]="url_pattern"
              required
            />
            <!-- pattern="http(s?)(:\/\/)((www.)?)(([^.]+)\.)?([a-zA-z0-9\-_]+)(\/[^\s]*)?" -->
          </div>
          <div *ngIf="OneXForm.submitted && xurl.invalid" class="float-left">
            <p class="error-msg mb-0 fs-14" *ngIf="xurl.errors.required">
              {{ "FORMERROR.PLAYLIST_URL" | translate }}
            </p>
            <p
              class="error-msg mb-0 fs-14"
              *ngIf="OneXForm.controls.xurl.errors.pattern"
            >
              {{ "FORMERROR.VALID_URL" | translate }}
            </p>
          </div>
        </div>
        <div class="col-12 mt-3">
          <button
            type="submit"
            class="btn button-info"
            (click)="addPlaylistOnestream(OneXForm)"
          >
            <i class="fa fa-plus px-2"></i
            >{{ "PLAYLIST.ADD_PLAYLIST" | translate }}
          </button>
        </div>
      </div>
    </form>
    <!-- <form #CodeForm="ngForm">
      <div class="row mt-3" *ngIf="playListModal.type == 'loginwithcode'">
    
      </div>
    </form> -->
  </div>
</ng-template>

<!-- Modal -->
<!-- <div
  #editModal
  class="modal fade"
  id="editPlaylistModal"
  tabindex="-1"
  aria-labelledby="editPlaylistModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Playlist</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label>Playlist Name</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="editModel.name"
              name="name"
            />
          </div>
          <div class="mb-3">
            <label>Username</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="editModel.username"
              name="username"
            />
          </div>
          <div class="mb-3">
            <label>Password</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="editModel.pwd"
              name="pwd"
            />
          </div>
          <div class="mb-3">
            <label>URL / DNS</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="editModel.url"
              name="url"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" >Close</button>
        <button class="btn btn-primary" (click)="saveEditPlaylist()">Save</button>
      </div>
    </div>
  </div>
</div> -->
